package com.milta.feature.optimizationquota.domain.usecase

import com.milta.core.network.PagedResult
import com.milta.feature.optimizationquota.domain.entity.OptimizationHistoryEntry
import com.milta.feature.optimizationquota.domain.repository.OptimizationQuotaRepository

class GetMyOptimizationHistoryUseCase(private val repository: OptimizationQuotaRepository) {
    suspend operator fun invoke(page: Int, pageSize: Int): Result<PagedResult<OptimizationHistoryEntry>> =
        repository.getMyHistory(page, pageSize)
}
